import { ApiService } from '../services.js'


export default {
    getBannersPreview(payload) {
        const { hash, subcampaigns, offers } = payload
        return ApiService.get('/preview/banner', {
            params: {
                hash,
                subcampaigns,
                offers
            }
        })
    },
    getUrlPreview(url) {
        return ApiService.get(`preview?url=${decodeURIComponent(url)}`)
    }
}